import React from 'react';
import CrossingOutBillReport from '../CrossingOutBillReport';

export default function CrossingOutBillReportPage({ sessionObject }) {

  return (
    <div className="page-bilty">
    <CrossingOutBillReport sessionObject={sessionObject} />
    </div>
  );
}
